import { render, staticRenderFns } from "./SettingsNotifications.vue?vue&type=template&id=91c8e486&scoped=true&"
import script from "./SettingsNotifications.vue?vue&type=script&lang=js&"
export * from "./SettingsNotifications.vue?vue&type=script&lang=js&"
import style0 from "./SettingsNotifications.vue?vue&type=style&index=0&id=91c8e486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c8e486",
  null
  
)

export default component.exports